import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import type { CustomerTestimonial } from '../types';

const TestimonialsCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials: CustomerTestimonial[] = [
  {
    id: "1",
    name: "Sarah Mitchell",
    position: "VP of Operations",
    company: "Retail Corporation",
    testimonial: "CamlytixAI transformed our store operations completely. We've seen a 40% increase in conversion rates and our staff allocation is now data-driven. The footfall analytics alone paid for the entire system in 6 months.",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c0007e95-1763295050768.png",
    alt: "Professional woman with short brown hair wearing navy blue blazer, smiling confidently in modern office setting",
    metrics: [
    { label: "Conversion Increase", value: "40%" },
    { label: "ROI Timeline", value: "6 months" },
    { label: "Staff Efficiency", value: "+35%" }]

  },
  {
    id: "2",
    name: "David Chen",
    position: "Chief Security Officer",
    company: "Tech Industry",
    testimonial: "The threat detection capabilities are phenomenal. We've reduced security incidents by 65% and our response time is now under 2 minutes. The system's accuracy and real-time alerts have made our campus significantly safer.",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_16ec19a17-1763296357606.png",
    alt: "Asian man in his forties wearing glasses and dark suit, professional headshot with office background",
    metrics: [
    { label: "Incident Reduction", value: "65%" },
    { label: "Response Time", value: "2 min" },
    { label: "Accuracy Rate", value: "99.8%" }]

  },
  {
    id: "3",
    name: "Maria Rodriguez",
    position: "Traffic Operations Director",
    company: "Metro City Authority",
    testimonial: "Implementing CamlytixAI for our ATCC system was game-changing. Traffic flow improved by 30%, violations are detected automatically, and our citizens are experiencing significantly reduced congestion during peak hours.",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f225624a-1763293838525.png",
    alt: "Hispanic woman with long dark hair in professional attire, warm smile, city government office background",
    metrics: [
    { label: "Traffic Improvement", value: "30%" },
    { label: "Violation Detection", value: "Automated" },
    { label: "Congestion Reduction", value: "45%" }]

  }];


  const handlePrevious = () => {
    setCurrentIndex((prev) => prev === 0 ? testimonials.length - 1 : prev - 1);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => prev === testimonials.length - 1 ? 0 : prev + 1);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-success/10 rounded-full mb-4">
            <Icon name="Award" size={16} className="text-success mr-2" />
            <span className="text-sm font-medium text-success">Success Stories</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Trusted by Industries
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Real results from organizations that transformed operations with Camlytix AI
          </p>
        </div>

        <div className="relative">
          <div className="bg-gradient-to-br from-card to-muted rounded-2xl p-8 md:p-12 shadow-brand-lg">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div className="space-y-6">
                <div className="flex items-center gap-4">
                  {/* <div className="relative">
                    <Image
                      src={currentTestimonial.avatar}
                      alt={currentTestimonial.alt}
                      className="w-20 h-20 rounded-full object-cover" />

                    <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                      <Icon name="Quote" size={16} className="text-primary-foreground" />
                    </div>
                  </div> */}
                  <div>
                    {/* <div className="font-bold text-foreground text-lg">
                      {currentTestimonial.name}
                    </div>
                    <div className="text-text-secondary text-sm">
                      {currentTestimonial.position}
                    </div> */}
                    <div className="text-primary text-sm font-medium">
                      {currentTestimonial.company}
                    </div>
                  </div>
                </div>

                <blockquote className="text-foreground text-lg leading-relaxed italic">
                  "{currentTestimonial.testimonial}"
                </blockquote>

                <div className="flex items-center gap-4 pt-4">
                  <Button
                    variant="outline"
                    size="icon"
                    onClick={handlePrevious}
                    aria-label="Previous testimonial">

                    <Icon name="ChevronLeft" size={20} />
                  </Button>
                  <div className="flex gap-2">
                    {testimonials.map((_, index) =>
                    <button
                      key={index}
                      onClick={() => setCurrentIndex(index)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 ${
                      index === currentIndex ?
                      'bg-primary w-8' : 'bg-border hover:bg-primary/50'}`
                      }
                      aria-label={`Go to testimonial ${index + 1}`} />

                    )}
                  </div>
                  <Button
                    variant="outline"
                    size="icon"
                    onClick={handleNext}
                    aria-label="Next testimonial">

                    <Icon name="ChevronRight" size={20} />
                  </Button>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-4">
                {currentTestimonial.metrics.map((metric, index) =>
                <div
                  key={index}
                  className="bg-background rounded-xl p-6 text-center shadow-brand">

                    <div className="text-3xl font-bold text-primary mb-2">
                      {metric.value}
                    </div>
                    <div className="text-sm text-text-secondary">
                      {metric.label}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default TestimonialsCarousel;